const footerColumns = [
  {
    title: '深挖栏目',
    links: [
      { label: '娱乐圈内幕', href: '#channels' },
      { label: '网红圈潜规则', href: '#channels' },
      { label: '饭圈操作', href: '#channels' },
    ],
  },
  {
    title: '内容形态',
    links: [
      { label: '今日快讯时间线', href: '#feed' },
      { label: '封面深挖专题', href: '#deepdive' },
      { label: '幕后推手图谱', href: '#pushers' },
    ],
  },
  {
    title: '参与方式',
    links: [
      { label: '读者热评', href: '#voices' },
      { label: '匿名提交线索', href: '#subscribe' },
      { label: '订阅深挖周刊', href: '#subscribe' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                17
              </span>
              <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">17爆料网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              17爆料网持续整理娱乐圈内幕、网红圈潜规则与饭圈操作的公开线索，
              关注资本运作与幕后推手的协作方式，尽量把行业黑幕写成可以被核对的事实。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['内幕深挖', '推手档案', '时间线整理', '材料核验'].map((tag) => (
                <span key={tag} className="rounded-full bg-background-200 px-3 py-1 text-[11px] text-foreground-700">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="transition-colors hover:text-primary-600">
                  {column.title}
                </a>
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h4 className="font-heading text-sm font-bold text-foreground-950">关注</h4>
            <div className="mt-4 flex gap-2 lg:flex-col">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line', 'ri-rss-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-foreground-500">
            © 2026 17爆料网 · 本站内容为公开线索整理与行业观察，涉及具体主体时以可核验材料为准。
          </p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-foreground-500">
            <a href="#top" className="transition-colors hover:text-primary-600">
              内容准则
            </a>
            <a href="#top" className="transition-colors hover:text-primary-600">
              线索处理说明
            </a>
            <a href="#top" className="transition-colors hover:text-primary-600">
              纠错与申诉
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}